import { render, staticRenderFns } from "./PlayBtn.vue?vue&type=template&id=2f7594f2&lang=html&"
import script from "./PlayBtn.vue?vue&type=script&lang=js&"
export * from "./PlayBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports